import { render } from "./ModalAddAdress2.vue?vue&type=template&id=19b6166c&scoped=true&ts=true"
import script from "./ModalAddAdress2.vue?vue&type=script&lang=ts"
export * from "./ModalAddAdress2.vue?vue&type=script&lang=ts"

import "./ModalAddAdress2.vue?vue&type=style&index=0&id=19b6166c&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19b6166c"]])

export default __exports__